import {
  convertFrequency,
  getContentsErrorText,
  getHouseErrorText,
  validateContentsAmount,
  validateHouseAmount,
} from 'helpers';
import {
  areaOfGaragingOptions,
  FREQUENCY,
  FREQUENCY_OPTIONS,
  PAYOUT_BENEFIT_OPTIONS,
  PAYOUT_FREQUENCY_OPTIONS,
  PAYOUT_WAIT_OPTIONS,
} from './options';
import {
  ADDRESS_QUESTION,
  AREA_OF_GARAGING_QUESTION,
  BUILD_YEAR_QUESTION,
  CC_RATING_QUESTION,
  COPAYMENT_QUESTION,
  EXCESS_QUESTION,
  EXTERNAL_AREA_QUESTION,
  FLOOR_AREA_QUESTION,
  INSURED_AMOUNT_QUESTION,
  MAKE_QUESTION,
  MODEL_QUESTION,
  MOTORCYCLE_REGO_QUESTION,
  PAYMENT_METHOD_QUESTION,
  REGO_QUESTION,
  REGO_STATUS_QUESTION,
  SUBMODEL_QUESTION,
  VEHICLE_YEAR_QUESTION,
} from './questions';
import carIcon from 'assets/icons/car.svg';
import motorbikeIcon from 'assets/icons/motorbike.svg';
import contentIcon from 'assets/icons/content.svg';
import creditCardIcon from 'assets/icons/credit-card.svg';
import disabilityIcon from 'assets/icons/disability.svg';
import healthIcon from 'assets/icons/health.svg';
import homeAndContentsIcon from 'assets/icons/home-and-contents.svg';
import homeIcon from 'assets/icons/home.svg';
import incomeIcon from 'assets/icons/income.svg';
import lifeIcon from 'assets/icons/life.svg';
import landlordIcon from 'assets/icons/landlord.svg';
import mortgageIcon from 'assets/icons/mortgage.svg';
import petIcon from 'assets/icons/pet.svg';
import rentersIcon from 'assets/icons/renters.svg';
import traumaIcon from 'assets/icons/trauma.svg';
import boatIcon from 'assets/icons/boat.svg';
import redundancyIcon from 'assets/icons/redundancy.svg';
import travelIcon from 'assets/icons/travel.svg';
import cancerIcon from 'assets/icons/cancer.svg';
import otherIcon from 'assets/icons/other.svg';
import bicycleIcon from 'assets/icons/bicycle.svg';
import mbiIcon from 'assets/icons/mbi.svg';
import rvIcon from 'assets/icons/rv.svg';
// providers
import aaIcon from 'assets/icons/aa.svg';
import masIcon from 'assets/icons/mas.svg';
import aiaIcon from 'assets/icons/aia.svg';
import allianzIcon from 'assets/icons/allianz.svg';
import amiIcon from 'assets/icons/ami.svg';
import ampIcon from 'assets/icons/amp.svg';
import assurantIcon from 'assets/icons/assurant.svg';
import autosureIcon from 'assets/icons/autosure.svg';
import bnzIcon from 'assets/icons/bnz.webp';
import coveIcon from 'assets/icons/cove.svg';
import initioIcon from 'assets/icons/initio.svg';
import oneChoiceIcon from 'assets/icons/onechoice.svg';
import partnersLifeIcon from 'assets/icons/partnerslife.svg';
import pinnacleLifeIcon from 'assets/icons/pinnaclelife.svg';
import providentIcon from 'assets/icons/provident.svg';
import stateIcon from 'assets/icons/state.svg';
import starIcon from 'assets/icons/star.webp';
import towerIcon from 'assets/icons/tower.svg';
import trademeIcon from 'assets/icons/trademe.svg';
// news icons

import { INSURANCE_TYPES_NAMES } from './insurance-types-names';

export const MBI_FULL_NAME = 'Mechanical Breakdown Insurance';

export const INSURANCE_TYPE_ALIAS = {
  [INSURANCE_TYPES_NAMES.MBI]: 'Mechanical Breakdown',
};

export { default as POLICY_BUNDLE_ICON } from 'images/bundle.svg';

export const INSURANCE_TYPES_ICONS_V2 = {
  [INSURANCE_TYPES_NAMES.VEHICLE]: carIcon,
  [INSURANCE_TYPES_NAMES.MOTORCYCLE]: motorbikeIcon,
  [INSURANCE_TYPES_NAMES.CONTENT]: contentIcon,
  [INSURANCE_TYPES_NAMES.CREDIT_CARD]: creditCardIcon,
  [INSURANCE_TYPES_NAMES.DISABILITY]: disabilityIcon,
  [INSURANCE_TYPES_NAMES.HEALTH]: healthIcon,
  [INSURANCE_TYPES_NAMES.HOME_CONTENTS]: homeAndContentsIcon,
  [INSURANCE_TYPES_NAMES.HOME]: homeIcon,
  [INSURANCE_TYPES_NAMES.INCOME]: incomeIcon,
  [INSURANCE_TYPES_NAMES.LIFE]: lifeIcon,
  [INSURANCE_TYPES_NAMES.LANDLORD]: landlordIcon,
  [INSURANCE_TYPES_NAMES.MORTGAGE]: mortgageIcon,
  [INSURANCE_TYPES_NAMES.PET]: petIcon,
  [INSURANCE_TYPES_NAMES.RENTERS]: rentersIcon,
  [INSURANCE_TYPES_NAMES.TRAUMA]: traumaIcon,
  [INSURANCE_TYPES_NAMES.BOAT]: boatIcon,
  [INSURANCE_TYPES_NAMES.REDUNDANCY]: redundancyIcon,
  [INSURANCE_TYPES_NAMES.TRAVEL]: travelIcon,
  [INSURANCE_TYPES_NAMES.CANCER]: cancerIcon,
  [INSURANCE_TYPES_NAMES.OTHER]: otherIcon,
  [INSURANCE_TYPES_NAMES.RV]: otherIcon,
  [INSURANCE_TYPES_NAMES.BICYCLE]: bicycleIcon,
  [INSURANCE_TYPES_NAMES.MBI]: mbiIcon,
  [INSURANCE_TYPES_NAMES.RV]: rvIcon,
  default: otherIcon,
};

import { CarIconV2 } from 'components/svgs/CarIconV2';
import { ContentIconV2 } from 'components/svgs/ContentIconV2';
import { MotorbikeIconV2 } from 'components/svgs/MotorbikeIconV2';
import { CreditCardIconV2 } from 'components/svgs/CreditCardIconV2';
import { DisabilityIconV2 } from 'components/svgs/DisabilityIconV2';
import { HealthIconV2 } from 'components/svgs/HealthIconV2';
import { HomeAndContentsIconV2 } from 'components/svgs/HomeContentsIconV2';
import { HomeIconV2 } from 'components/svgs/HomeIconV2';
import { IncomeIconV2 } from 'components/svgs/IncomeIconV2';
import { LifeIconV2 } from 'components/svgs/LifeIconV2';
import { LandlordIconV2 } from 'components/svgs/LandlordIconV2';
import { MortgageIconV2 } from 'components/svgs/MortgageIconV2';
import { PetIconV2 } from 'components/svgs/PetIconV2';
import { RenterIconV2 } from 'components/svgs/RenterIconV2';
import { TraumaIconV2 } from 'components/svgs/TraumaIconV2';
import { BoatIconV2 } from 'components/svgs/BoatIconV2';
import { RedundancyIconV2 } from 'components/svgs/RedundancyIconV2';
import { TravelIconV2 } from 'components/svgs/TravelIconV2';
import { CancerIconV2 } from 'components/svgs/CancerIconV2';
import { MBIIconV2 } from 'components/svgs/MBIIconV2';
import { RVIconV2 } from 'components/svgs/RVIconV2';
import { OtherIconV2 } from 'components/svgs/OtherIconV2';

export const INSURANCE_TYPES_ICONS_SVG_V2 = {
  [INSURANCE_TYPES_NAMES.VEHICLE]: CarIconV2,
  [INSURANCE_TYPES_NAMES.MOTORCYCLE]: MotorbikeIconV2,
  [INSURANCE_TYPES_NAMES.CONTENT]: ContentIconV2,
  [INSURANCE_TYPES_NAMES.CREDIT_CARD]: CreditCardIconV2,
  [INSURANCE_TYPES_NAMES.DISABILITY]: DisabilityIconV2,
  [INSURANCE_TYPES_NAMES.HEALTH]: HealthIconV2,
  [INSURANCE_TYPES_NAMES.HOME_CONTENTS]: HomeAndContentsIconV2,
  [INSURANCE_TYPES_NAMES.HOME]: HomeIconV2,
  [INSURANCE_TYPES_NAMES.INCOME]: IncomeIconV2,
  [INSURANCE_TYPES_NAMES.LIFE]: LifeIconV2,
  [INSURANCE_TYPES_NAMES.ACCIDENTAL_INJURY]: LifeIconV2,
  [INSURANCE_TYPES_NAMES.LANDLORD]: LandlordIconV2,
  [INSURANCE_TYPES_NAMES.MORTGAGE]: MortgageIconV2,
  [INSURANCE_TYPES_NAMES.PET]: PetIconV2,
  [INSURANCE_TYPES_NAMES.RENTERS]: RenterIconV2,
  [INSURANCE_TYPES_NAMES.RENT_PROTECTION]: RenterIconV2,
  [INSURANCE_TYPES_NAMES.TRAUMA]: TraumaIconV2,
  [INSURANCE_TYPES_NAMES.BOAT]: BoatIconV2,
  [INSURANCE_TYPES_NAMES.REDUNDANCY]: RedundancyIconV2,
  [INSURANCE_TYPES_NAMES.TRAVEL]: TravelIconV2,
  [INSURANCE_TYPES_NAMES.CANCER]: CancerIconV2,
  [INSURANCE_TYPES_NAMES.MBI]: MBIIconV2,
  [INSURANCE_TYPES_NAMES.RV]: RVIconV2,
  [INSURANCE_TYPES_NAMES.OTHER]: OtherIconV2,
  default: OtherIconV2,
};

export const INSURANCE_TYPES_COLOR_MAP = {
  [INSURANCE_TYPES_NAMES.VEHICLE]: '#FF6565',
  [INSURANCE_TYPES_NAMES.CONTENT]: '#BF3487',
  [INSURANCE_TYPES_NAMES.CREDIT_CARD]: '',
  [INSURANCE_TYPES_NAMES.DISABILITY]: '#D3E1B5',
  [INSURANCE_TYPES_NAMES.HEALTH]: '#95B828',
  [INSURANCE_TYPES_NAMES.HOME_CONTENTS]:
    'linear-gradient(to bottom, #FFC01F 50%, #BF3487 50%)',
  [INSURANCE_TYPES_NAMES.HOME]: '#FFC01F',
  [INSURANCE_TYPES_NAMES.INCOME]: '#3D67AB',
  [INSURANCE_TYPES_NAMES.LIFE]: '#4D4E4B',
  [INSURANCE_TYPES_NAMES.LANDLORD]: '#FFE68F',
  [INSURANCE_TYPES_NAMES.MORTGAGE]: '#4187F5',
  [INSURANCE_TYPES_NAMES.PET]: '#FE94D4',
  [INSURANCE_TYPES_NAMES.RENTERS]: '#FDD7EE',
  [INSURANCE_TYPES_NAMES.TRAUMA]: '#83A48C',
  [INSURANCE_TYPES_NAMES.BOAT]: '#FFCDA9',
  [INSURANCE_TYPES_NAMES.REDUNDANCY]: '#CADEFE',
  [INSURANCE_TYPES_NAMES.TRAVEL]: '#B0A0D2',
  [INSURANCE_TYPES_NAMES.CANCER]: '#C598C8',
  [INSURANCE_TYPES_NAMES.MOTORCYCLE]: '#F0761D',
  [INSURANCE_TYPES_NAMES.RV]: '#228B22',
  q4e: 'rgba(65, 135, 245, 0.5)',
  creditCard: '#EBEDF3',
  default: '#34363E',
};

export const INSURANCE_TYPES_COLOR_MAP_V2 = {
  [INSURANCE_TYPES_NAMES.VEHICLE]: '#EB1203',
  [INSURANCE_TYPES_NAMES.LIFE]: '#4D4E4B',
  [INSURANCE_TYPES_NAMES.CONTENT]: '#B92689',
  [INSURANCE_TYPES_NAMES.HOME_CONTENTS]:
    'linear-gradient(to bottom, #F8C100, #B92688)',
};

export const ADVISER_INSURANCE_TYPES_ICONS = {
  [INSURANCE_TYPES_NAMES.OTHER]: require('images/icons/new_other_insurance_icon.webp'),
  [INSURANCE_TYPES_NAMES.LIFE]: require('images/icons/new_life_insurance_icon.webp'),
};

const VESSEL_FIELD = {
  fieldKey: 'vessel',
  placeholder: 'Vessel',
  label: 'Vessel',
  required: true,
};

export const NAME_FIELD = {
  fieldKey: 'name',
  placeholder: 'Name',
  label: 'Name',
  required: true,
};

const ADDRESS_FIELD = {
  ...ADDRESS_QUESTION,
  placeholder: 'Insured address',
};

const PROPERTY_INSURED_FIELD = {
  ...ADDRESS_FIELD,
  placeholder: 'Property insured',
  label: 'Property insured',
};

const MULTIPLE_INSURED_FIELD = {
  fieldKey: 'name',
  placeholder: 'Name',
  label: 'Name',
  required: true,
  multiple: true,
  as: 'insured',
};

const PET_NAME_FIELD = {
  fieldKey: 'petName',
  placeholder: 'Pet Name',
  label: 'Pet Name',
  required: true,
};

export const INSURANCE_QUESTIONS_BY_TYPE = {
  [INSURANCE_TYPES_NAMES.VEHICLE]: [REGO_QUESTION],
  [INSURANCE_TYPES_NAMES.MBI]: [REGO_QUESTION],
  [INSURANCE_TYPES_NAMES.RV]: [REGO_QUESTION],
  [INSURANCE_TYPES_NAMES.MOTORCYCLE]: [MOTORCYCLE_REGO_QUESTION],
  [INSURANCE_TYPES_NAMES.BOAT]: [VESSEL_FIELD],
  [INSURANCE_TYPES_NAMES.CONTENT]: [ADDRESS_FIELD],
  [INSURANCE_TYPES_NAMES.HOME_CONTENTS]: [ADDRESS_FIELD],
  [INSURANCE_TYPES_NAMES.HOME]: [R.assoc('showWarning', true, ADDRESS_FIELD)],
  [INSURANCE_TYPES_NAMES.RENTERS]: [ADDRESS_FIELD],
  [INSURANCE_TYPES_NAMES.HEALTH]: [NAME_FIELD],
  [INSURANCE_TYPES_NAMES.CREDIT_CARD]: [NAME_FIELD],
  [INSURANCE_TYPES_NAMES.DISABILITY]: [NAME_FIELD],
  [INSURANCE_TYPES_NAMES.INCOME]: [NAME_FIELD],
  [INSURANCE_TYPES_NAMES.MORTGAGE]: [NAME_FIELD],
  [INSURANCE_TYPES_NAMES.REDUNDANCY]: [NAME_FIELD],
  [INSURANCE_TYPES_NAMES.TRAUMA]: [NAME_FIELD],
  [INSURANCE_TYPES_NAMES.TRAVEL]: [NAME_FIELD],
  [INSURANCE_TYPES_NAMES.LANDLORD]: [PROPERTY_INSURED_FIELD],
  [INSURANCE_TYPES_NAMES.LIFE]: [MULTIPLE_INSURED_FIELD],
  [INSURANCE_TYPES_NAMES.PET]: [PET_NAME_FIELD],
  [INSURANCE_TYPES_NAMES.CANCER]: [NAME_FIELD],
  [INSURANCE_TYPES_NAMES.OTHER]: [NAME_FIELD],
};

export const POLICY_PROVIDER_QUESTION = {
  fieldKey: 'policyProvider',
  placeholder: 'Insurance provider',
  required: true,
  type: 'dropdown',
  validationKey: 'policyProviderId',
  valueKey: 'policyProviderId',
  search: true,
};

export const RENEWAL_DATE_QUESTION = {
  fieldKey: 'renewalDate',
  placeholder: 'Policy renewal date',
  required: true,
  type: 'date',
};

const RENEWAL_DATE_DETAILS_QUESTION = {
  key: 'renewalDate',
  fieldKey: 'renewalDate',
  label: 'Renewal date',
  before: 'Renewal date',
  type: 'date',
  showKeyValue: R.prop('premium'),
};

export const INSURANCE_QUESTIONS_COMMON = [
  POLICY_PROVIDER_QUESTION,
  { fieldKey: 'policyNumber', placeholder: 'Policy number' },
];

export const INSURANCE_QUESTIONS_DATES = [RENEWAL_DATE_QUESTION];

export const TRAVEL_INSURANCE_QUESTIONS_DATES = [
  {
    fieldKey: 'startDate',
    placeholder: 'Policy start date',
    type: 'date',
  },
  {
    fieldKey: 'renewalDate',
    placeholder: 'Policy end date',
    required: true,
    type: 'date',
  },
];

export const PREMIUM_QUESTION = {
  key: 'premium',
  fieldKey: 'premium',
  placeholder: 'Premium amount',
  label: 'Premium',
  before: 'Premium',
  required: true,
  inputType: 'number',
  type: 'number',
  prefix: '$',
  warning: (value, freq) =>
    convertFrequency(value, freq, FREQUENCY.YEARLY) > 8000,
};

export const FREQUENCY_QUESTION = {
  fieldKey: 'frequency',
  placeholder: 'Payment frequency',
  required: true,
  type: 'dropdown',
};

export const INSURANCE_QUESTIONS_PAYMENTS = [
  PREMIUM_QUESTION,
  FREQUENCY_QUESTION,
  PAYMENT_METHOD_QUESTION,
];

export const INSURANCE_QUESTIONS_OPTIONAL = [
  EXCESS_QUESTION,
  INSURED_AMOUNT_QUESTION,
];

export const PET_INSURANCE_QUESTIONS_OPTIONAL = [
  COPAYMENT_QUESTION,
  EXCESS_QUESTION,
  INSURED_AMOUNT_QUESTION,
];

export const OTHER_INSURANCE_QUESTIONS_OPTIONAL = [
  EXCESS_QUESTION,
  INSURED_AMOUNT_QUESTION,
  {
    fieldKey: 'notes',
    placeholder: 'Notes',
    label: 'Notes',
    maxLength: 512,
  },
];

const EXCESS_HOME_QUESTION = {
  ...EXCESS_QUESTION,
  fieldKey: 'excessHome',
  placeholder: 'Main excess - Home',
  label: 'Main excess - Home',
};

const EXCESS_CONTENTS_QUESTION = {
  ...EXCESS_QUESTION,
  fieldKey: 'excessContents',
  placeholder: 'Main excess - Contents',
  label: 'Main excess - Contents',
};

export const HOME_CONTENT_INSURANCE_QUESTIONS_OPTIONAL = [
  EXCESS_HOME_QUESTION,
  EXCESS_CONTENTS_QUESTION,
  {
    ...INSURED_AMOUNT_QUESTION,
    fieldKey: 'amountHome',
    placeholder: 'Insured amount - Home',
  },
  {
    ...INSURED_AMOUNT_QUESTION,
    fieldKey: 'amountContents',
    placeholder: 'Insured amount - Contents',
  },
];

export const LANDLORD_INSURANCE_QUESTIONS_OPTIONAL = [
  {
    ...EXCESS_HOME_QUESTION,
    placeholder: 'Main excess - Rental home',
  },
  {
    ...EXCESS_CONTENTS_QUESTION,
    placeholder: 'Main excess - Rental contents',
  },
  {
    ...INSURED_AMOUNT_QUESTION,
    fieldKey: 'amountHome',
    placeholder: 'Insured amount - Rental home',
  },
  {
    ...INSURED_AMOUNT_QUESTION,
    fieldKey: 'amountContents',
    placeholder: 'Insured amount- Rental contents',
  },
];

export const VEHICLE_INSURANCE_QUESTIONS_OPTIONAL = [
  ...INSURANCE_QUESTIONS_OPTIONAL,
  R.assoc('required', false, ADDRESS_FIELD),
];

const PAYOUT_FREQUENCY_FIELD = {
  fieldKey: 'payoutFrequency',
  type: 'dropdown',
  options: PAYOUT_FREQUENCY_OPTIONS,
};

const PAYOUT_WAIT_FIELD = {
  fieldKey: 'payoutWaitPeriod',
  type: 'dropdown',
  options: PAYOUT_WAIT_OPTIONS,
};

const PAYOUT_BENEFIT_FIELD = {
  fieldKey: 'payoutBenefitPeriod',
  type: 'dropdown',
  options: PAYOUT_BENEFIT_OPTIONS,
};

const PAYOUT_QUESTIONS = [
  {
    ...PAYOUT_FREQUENCY_FIELD,
    placeholder: 'Payout frequency',
  },
  {
    ...PAYOUT_WAIT_FIELD,
    placeholder: 'Payout wait period',
  },
  {
    ...PAYOUT_BENEFIT_FIELD,
    placeholder: 'Benefit period',
  },
];

export const PAYOUT_QUESTIONS_OPTIONAL = [
  ...INSURANCE_QUESTIONS_OPTIONAL,
  ...PAYOUT_QUESTIONS,
];

export const INSURANCE_QUESTIONS_OPTIONAL_BY_NAME = {
  [INSURANCE_TYPES_NAMES.HOME_CONTENTS]:
    HOME_CONTENT_INSURANCE_QUESTIONS_OPTIONAL,
  [INSURANCE_TYPES_NAMES.LANDLORD]: LANDLORD_INSURANCE_QUESTIONS_OPTIONAL,
  [INSURANCE_TYPES_NAMES.PET]: PET_INSURANCE_QUESTIONS_OPTIONAL,
  [INSURANCE_TYPES_NAMES.VEHICLE]: VEHICLE_INSURANCE_QUESTIONS_OPTIONAL,
  [INSURANCE_TYPES_NAMES.MOTORCYCLE]: VEHICLE_INSURANCE_QUESTIONS_OPTIONAL,
  [INSURANCE_TYPES_NAMES.INCOME]: PAYOUT_QUESTIONS_OPTIONAL,
  [INSURANCE_TYPES_NAMES.MORTGAGE]: PAYOUT_QUESTIONS_OPTIONAL,
  [INSURANCE_TYPES_NAMES.RENT_PROTECTION]: PAYOUT_QUESTIONS_OPTIONAL,
  [INSURANCE_TYPES_NAMES.OTHER]: OTHER_INSURANCE_QUESTIONS_OPTIONAL,
  default: INSURANCE_QUESTIONS_OPTIONAL,
};

export const INSURANCE_SUB_TYPE_QUESTION = {
  key: 'policySubType',
  fieldKey: 'policySubType',
  placeholder: 'Policy Type',
  label: 'Policy Type',
  before: 'Policy Type',
  type: 'dropdown',
  valueKey: 'policySubTypeId',
  validationKey: 'policySubTypeId',
  requiredFor: [INSURANCE_TYPES_NAMES.VEHICLE],
};

export const INSURANCE_PROVIDER_QUESTION = {
  fieldKey: 'policyProvider',
  label: 'Insurer',
  type: 'dropdown',
  valueKey: 'policyProviderId',
  handlerName: 'handleDropdownIdNameChange',
};

export const INSURANCE_DETAILS_FIELDS = [
  { fieldKey: 'policyType', label: 'Insured', disabled: true },
  {
    ...INSURANCE_SUB_TYPE_QUESTION,
    placeholder: '',
    handlerName: 'handleDropdownIdNameChange',
  },
  {
    ...PREMIUM_QUESTION,
    placeholder: '',
    required: false,
    showKeyValue: R.prop('id'),
  },
  {
    key: 'frequency',
    fieldKey: 'frequency',
    label: 'Payment frequency',
    before: 'Payment frequency',
    type: 'dropdown',
    handlerName: 'onFrequencyChange',
    options: FREQUENCY_OPTIONS,
    showKeyValue: R.prop('premium'),
  },
  PAYMENT_METHOD_QUESTION,
  {
    fieldKey: 'policyNumber',
    key: 'policyNumber',
    label: 'Policy number',
    before: 'Policy number',
  },
  {
    key: 'renewalDate',
    fieldKey: 'renewalDate',
    label: 'Renewal date',
    before: 'Renewal date',
    type: 'date',
    showKeyValue: R.prop('premium'),
  },
  {
    ...EXCESS_QUESTION,
    exclude: INSURANCE_TYPES_NAMES.LIFE,
  },
  {
    ...INSURED_AMOUNT_QUESTION,
    placeholder: '',
    exclude: INSURANCE_TYPES_NAMES.LIFE,
  },
];

export const HOME_BUILD_FIELDS = [
  {
    ...BUILD_YEAR_QUESTION,
    showKeyValue: ({ addressValid }) => addressValid === false,
    exclude: INSURANCE_TYPES_NAMES.HOME,
  },
  {
    fieldKey: 'numberOfStories',
    label: 'Storeys',
    type: 'dropdown',
    showKeyValue: ({ addressValid }) => addressValid === false,
    exclude: INSURANCE_TYPES_NAMES.HOME,
  },
  {
    ...FLOOR_AREA_QUESTION,
    showKeyValue: ({ addressValid }) => addressValid === false,
    exclude: INSURANCE_TYPES_NAMES.HOME,
  },
  {
    ...EXTERNAL_AREA_QUESTION,
    showKeyValue: ({ addressValid }) => addressValid === false,
    exclude: INSURANCE_TYPES_NAMES.HOME,
    optional: true,
  },
  {
    fieldKey: 'constructionType',
    label: 'Wall material',
    type: 'dropdown',
    showKeyValue: ({ addressValid }) => addressValid === false,
    exclude: INSURANCE_TYPES_NAMES.HOME,
  },
  {
    fieldKey: 'roofType',
    label: 'Roof material',
    type: 'dropdown',
    showKeyValue: ({ addressValid }) => addressValid === false,
    exclude: INSURANCE_TYPES_NAMES.HOME,
  },
  {
    fieldKey: 'slope',
    label: 'Slope',
    type: 'dropdown',
    showKeyValue: ({ addressValid }) => addressValid === false,
    exclude: INSURANCE_TYPES_NAMES.HOME,
  },
  {
    fieldKey: 'quality',
    label: 'Construction quality',
    type: 'dropdown',
    showKeyValue: ({ addressValid }) => addressValid === false,
    exclude: INSURANCE_TYPES_NAMES.HOME,
  },
];

export const CONTENTS_INSURANCE_DETAILS_FIELDS = [
  ...R.init(INSURANCE_DETAILS_FIELDS),
  {
    ...INSURED_AMOUNT_QUESTION,
    getErrorText: (value) => getContentsErrorText(value),
    validator: (value) => validateContentsAmount(value),
  },
];

export const HOME_INSURANCE_DETAILS_FIELDS = [
  ...R.init(INSURANCE_DETAILS_FIELDS),
  {
    ...INSURED_AMOUNT_QUESTION,
    getErrorText: (value, form) => getHouseErrorText(value, form.livingArea),
    validator: (value, form) =>
      form.livingArea ? validateHouseAmount(value, form.livingArea) : !!value,
  },
  ...HOME_BUILD_FIELDS,
];

export const HOME_CONTENTS_INSURANCE_DETAILS_FIELDS = [
  ...INSURANCE_DETAILS_FIELDS.filter(
    (f) => f.fieldKey !== 'amount' && f.fieldKey !== 'excess',
  ),
  EXCESS_HOME_QUESTION,
  EXCESS_CONTENTS_QUESTION,
  {
    ...INSURED_AMOUNT_QUESTION,
    fieldKey: 'amountHome',
    label: 'Insured amount - Home',
  },
  {
    ...INSURED_AMOUNT_QUESTION,
    fieldKey: 'amountContents',
    label: 'Insured amount - Contents',
  },
];

export const LANDLORD_INSURANCE_DETAILS_FIELDS = [
  ...INSURANCE_DETAILS_FIELDS.filter(
    (f) => f.fieldKey !== 'amount' && f.fieldKey !== 'excess',
  ),
  {
    ...EXCESS_HOME_QUESTION,
    label: 'Main excess - Rental home',
  },
  {
    ...EXCESS_CONTENTS_QUESTION,
    label: 'Main excess - Rental contents',
    optional: true,
  },
  {
    ...INSURED_AMOUNT_QUESTION,
    fieldKey: 'amountHome',
    placeholder: 'Insured amount - Rental home',
    label: 'Insured amount - Rental home',
  },
  {
    ...INSURED_AMOUNT_QUESTION,
    fieldKey: 'amountContents',
    placeholder: 'Insured amount - Rental contents',
    label: 'Insured amount - Rental contents',
    optional: true,
  },
];

export const PET_INSURANCE_DETAILS_FIELDS = [
  ...INSURANCE_DETAILS_FIELDS,
  COPAYMENT_QUESTION,
];

export const OTHER_INSURANCE_DETAILS_FIELDS = [
  ...INSURANCE_DETAILS_FIELDS.filter(
    (f) => f.fieldKey !== 'amount' && f.fieldKey !== 'excess',
  ),
  ...OTHER_INSURANCE_QUESTIONS_OPTIONAL,
];

export const VEHICLE_INFO_FIELDS = [
  R.merge(MAKE_QUESTION, {
    exclude: INSURANCE_TYPES_NAMES.VEHICLE,
  }),
  R.merge(MODEL_QUESTION, {
    exclude: INSURANCE_TYPES_NAMES.VEHICLE,
  }),
  R.merge(SUBMODEL_QUESTION, {
    exclude: INSURANCE_TYPES_NAMES.VEHICLE,
  }),
  R.merge(VEHICLE_YEAR_QUESTION, {
    exclude: INSURANCE_TYPES_NAMES.VEHICLE,
  }),
  R.merge(AREA_OF_GARAGING_QUESTION, {
    exclude: INSURANCE_TYPES_NAMES.VEHICLE,
    options: areaOfGaragingOptions,
  }),
];

export const MOTORCYCLE_INFO_FIELDS = [
  R.merge(MAKE_QUESTION, {
    showKeyValue: undefined,
    exclude: INSURANCE_TYPES_NAMES.MOTORCYCLE,
  }),
  R.merge(MODEL_QUESTION, {
    showKeyValue: undefined,
    exclude: INSURANCE_TYPES_NAMES.MOTORCYCLE,
  }),
  R.merge(CC_RATING_QUESTION, {
    exclude: INSURANCE_TYPES_NAMES.MOTORCYCLE,
  }),
  R.merge(VEHICLE_YEAR_QUESTION, {
    exclude: INSURANCE_TYPES_NAMES.MOTORCYCLE,
  }),
  R.merge(REGO_STATUS_QUESTION, {
    exclude: INSURANCE_TYPES_NAMES.MOTORCYCLE,
  }),
  R.merge(AREA_OF_GARAGING_QUESTION, {
    exclude: INSURANCE_TYPES_NAMES.MOTORCYCLE,
    options: areaOfGaragingOptions,
  }),
];

export const VEHICLE_INSURANCE_DETAILS_FIELDS = [
  ...VEHICLE_INFO_FIELDS,
  ...INSURANCE_DETAILS_FIELDS,
  {
    ...ADDRESS_QUESTION,
    label: 'Insured Address',
    required: false,
    fullWidth: true,
  },
];

export const MOTORCYCLE_INSURANCE_DETAILS_FIELDS = [
  ...MOTORCYCLE_INFO_FIELDS,
  ...INSURANCE_DETAILS_FIELDS,
  {
    ...ADDRESS_QUESTION,
    label: 'Insured Address',
    required: false,
    fullWidth: true,
  },
];

const TRAVEL_INSURANCE_DETAILS_FIELDS = [
  ...R.reject(R.propEq('fieldKey', 'renewalDate'), INSURANCE_DETAILS_FIELDS),
  {
    key: 'startDate',
    fieldKey: 'startDate',
    label: 'Start date',
    before: 'Start date',
    type: 'date',
    showKeyValue: R.prop('premium'),
  },
  { ...RENEWAL_DATE_DETAILS_QUESTION, label: 'End date' },
];

export const ADDITIONAL_LIFE_COVERS_QUESTIONS = [
  {
    fieldKey: 'name',
    placeholder: 'Name',
    required: true,
  },
  {
    fieldKey: 'additionalCovers',
    placeholder: 'Select your covers',
    type: 'dropdown',
    multiple: true,
    required: true,
  },
  {
    fieldKey: 'premiumCover',
    label: 'Select if you have "Premium cover"',
    infoMsg:
      'An optional benefit you may have selected which covers you for payment of your premiums to keep your insurance in place while you are on claim and may not have the ability to earn an income.',
    inputType: 'checkbox',
  },
];

export const LIFE_INSURANCE_AMOUNT_FIELD = {
  fieldKey: 'insuredAmount',
  placeholder: 'Amount',
  prefix: '$',
  inputType: 'number',
};

export const LIFE_INSURANCE_OPTIONAL_FIELDS = {
  [INSURANCE_TYPES_NAMES.HEALTH]: [
    EXCESS_QUESTION,
    LIFE_INSURANCE_AMOUNT_FIELD,
  ],
  [INSURANCE_TYPES_NAMES.INCOME]: [
    ...PAYOUT_QUESTIONS,
    LIFE_INSURANCE_AMOUNT_FIELD,
  ],
  [INSURANCE_TYPES_NAMES.MORTGAGE]: [
    ...PAYOUT_QUESTIONS,
    LIFE_INSURANCE_AMOUNT_FIELD,
  ],
  [INSURANCE_TYPES_NAMES.RENT_PROTECTION]: [
    ...PAYOUT_QUESTIONS,
    LIFE_INSURANCE_AMOUNT_FIELD,
  ],
  default: [LIFE_INSURANCE_AMOUNT_FIELD],
};

export const LIFE_INSURANCE_FIELD_KEYS = [
  'name',
  'additionalCovers',
  'premiumCover',
];

export const FIELD_KEYS_FOR_MISSING_INFO_COMMON = [
  'renewalDate',
  'premium',
  'frequency',
  'policyProviderId',
];

export const FIELD_KEYS_FOR_COMPLETION_BY_NAME = {
  [INSURANCE_TYPES_NAMES.VEHICLE]: [
    ...FIELD_KEYS_FOR_MISSING_INFO_COMMON,
    'policySubTypeId',
  ],
  default: FIELD_KEYS_FOR_MISSING_INFO_COMMON,
};

export const FIELD_KEYS_EXCESS_BY_NAME = {
  [INSURANCE_TYPES_NAMES.HOME_CONTENTS]: ['excessHome', 'excessContents'],
  [INSURANCE_TYPES_NAMES.LANDLORD]: ['excessHome', 'excessContents'],
  default: ['excess'],
};

export const FIELD_KEYS_AMOUNT_BY_NAME = {
  [INSURANCE_TYPES_NAMES.HOME_CONTENTS]: ['amountHome', 'amountContents'],
  [INSURANCE_TYPES_NAMES.LANDLORD]: ['amountHome', 'amountContents'],
  default: ['amount'],
};

export const PAYOUT_INSURANCE_DETAILS_FIELDS = [
  ...INSURANCE_DETAILS_FIELDS,
  {
    ...PAYOUT_FREQUENCY_FIELD,
    label: 'Payout frequency',
    handlerName: 'onFrequencyChange',
    tooltip:
      'This is how often the insurer will make a payout to you e.g. monthly, lump sum, etc.',
  },
  {
    ...PAYOUT_WAIT_FIELD,
    label: 'Payout wait period',
    handlerName: 'onFrequencyChange',
    tooltip:
      'This is how many days you must wait, from the date of your illness or injury, before your insurer will start to make a payout to you.',
  },
  {
    ...PAYOUT_BENEFIT_FIELD,
    label: 'Benefit period',
    handlerName: 'onFrequencyChange',
    tooltip:
      'This is the maximum amount of time you can receive the payout as part of your policy.',
  },
];

export const INSURANCE_DETAILS_FIELDS_BY_NAME = {
  [INSURANCE_TYPES_NAMES.HOME]: HOME_INSURANCE_DETAILS_FIELDS,
  [INSURANCE_TYPES_NAMES.HOME_CONTENTS]: HOME_CONTENTS_INSURANCE_DETAILS_FIELDS,
  [INSURANCE_TYPES_NAMES.INCOME]: PAYOUT_INSURANCE_DETAILS_FIELDS,
  [INSURANCE_TYPES_NAMES.LANDLORD]: LANDLORD_INSURANCE_DETAILS_FIELDS,
  [INSURANCE_TYPES_NAMES.MORTGAGE]: PAYOUT_INSURANCE_DETAILS_FIELDS,
  [INSURANCE_TYPES_NAMES.OTHER]: OTHER_INSURANCE_DETAILS_FIELDS,
  [INSURANCE_TYPES_NAMES.PET]: PET_INSURANCE_DETAILS_FIELDS,
  [INSURANCE_TYPES_NAMES.VEHICLE]: VEHICLE_INSURANCE_DETAILS_FIELDS,
  [INSURANCE_TYPES_NAMES.MOTORCYCLE]: MOTORCYCLE_INSURANCE_DETAILS_FIELDS,
  [INSURANCE_TYPES_NAMES.CONTENT]: CONTENTS_INSURANCE_DETAILS_FIELDS,
  [INSURANCE_TYPES_NAMES.TRAVEL]: TRAVEL_INSURANCE_DETAILS_FIELDS,
  default: INSURANCE_DETAILS_FIELDS,
};

export enum InsuranceCategory {
  LIFE = 'life',
  GENERAL = 'general',
}

export const MS_WATING_TESTIMONIALS = [
  {
    user: '100,000+',
    feedback: 'Kiwi consumers have signed up to shop and save their insurance with us.',
  },
  {
    user: 'Chuck, W',
    feedback: 'Quashed made it very easy… with the comparisons and in the process saved over $500 on one car.',
  },
  {
    user: 'Quinn, M',
    feedback: 'I have already recommended Quashed to many family and friends. This is fantastic. Thank you.',
  },
  {
    user: 'Isaac, O',
    feedback: 'Easy to use, saved me about $700/year on my house insurance alone and with better cover/perks.',
  },
  {
    user: 'Casey, H',
    feedback: 'Helpful tool, just that my current insurance is cheaper.',
  },
  {
    user: 'Zara, C',
    feedback: 'It was very simple and easy to use. Especially if you have your current policy documents handy.',
  },
  {
    user: 'Chris, P',
    feedback: 'I ended up saving nearly $1,300 on my annual car insurance!',
  },
  {
    user: 'Mala, P',
    feedback: 'It\'s pretty accurate. Good service.',
  },
  {
    user: 'Desmond, C',
    feedback: 'I was looking for a site that could compare actual quotes from insurance companies…',
  },
  {
    user: 'Yvette, F',
    feedback: 'I used your service and as a result I switched both my car and contents insurance… thanks so much!',
  },
  {
    user: 'Lian, G',
    feedback: 'Excellent site! I saved $300 off my existing policy.',
  },
  {
    user: 'Kate, G',
    feedback: 'Useful tool to check whether our current prices are competitive - which they are',
  },
];

export const providerLogoIcons = {
  aa: aaIcon,
  mas: masIcon,
  aia: aiaIcon,
  allianz: allianzIcon,
  ami: amiIcon,
  amp: ampIcon,
  bnz: bnzIcon,
  protecta: assurantIcon,
  autosure: autosureIcon,
  cove: coveIcon,
  initio: initioIcon,
  oneChoice: oneChoiceIcon,
  'partners life': partnersLifeIcon,
  'pinnacle life': pinnacleLifeIcon,
  provident: providentIcon,
  state: stateIcon,
  'star insure': starIcon,
  tower: towerIcon,
  'trade me insurance': trademeIcon,
};

